var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShares(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3642 6.61049C9.59188 6.03376 10.4081 6.03376 10.6358 6.61049V6.61049C10.7668 6.94222 11.1308 7.11752 11.4718 7.01308V7.01308C12.0646 6.8315 12.5736 7.46966 12.2646 8.00726V8.00726C12.0869 8.31648 12.1768 8.71036 12.4711 8.91185V8.91185C12.9827 9.26217 12.8011 10.0579 12.1881 10.1516V10.1516C11.8356 10.2054 11.5837 10.5213 11.6096 10.877V10.877C11.6547 11.4954 10.9193 11.8496 10.4639 11.4287V11.4287C10.202 11.1867 9.798 11.1867 9.53607 11.4287V11.4287C9.0807 11.8496 8.3453 11.4954 8.39039 10.877V10.877C8.41633 10.5213 8.16444 10.2054 7.81188 10.1516V10.1516C7.19894 10.0579 7.01732 9.26217 7.52892 8.91185V8.91185C7.8232 8.71036 7.9131 8.31648 7.73539 8.00726V8.00726C7.42644 7.46966 7.93536 6.8315 8.52822 7.01308V7.01308C8.86924 7.11752 9.23323 6.94222 9.3642 6.61049V6.61049Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14L5 14",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C3 7 5 5 5 3M15 3C15 5 17 7 19 7M19 17L1 17L1 3L19 3L19 17Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShares);
export default __webpack_public_path__ + "static/media/shares.6ca5478c6553492a82cd0805331f310b.svg";
export { ForwardRef as ReactComponent };